<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg4659"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs4663"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath4673"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path4671" /></clipPath></defs><g
     id="g4665"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g4667"><g
         id="g4669"
         clip-path="url(#clipPath4673)"><g
           id="g4675"
           transform="translate(7.5,82.4404)"><path
             d="M 0,0 85.317,92.924"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4677" /></g><g
           id="g4679"
           transform="translate(175.3301,128.3701)"><path
             d="M 0,0 -99.65,-108.53"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4681" /></g><g
           id="g4683"
           transform="translate(175.3301,171.2197)"><path
             d="M 0,0 V -44.689 C 0,-53.79 7.38,-61.17 16.49,-61.17 h 130.32"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4685" /></g><g
           id="g4687"
           transform="translate(175.3301,438.7998)"><path
             d="m 0,0 v 36.87 c 0,9.11 7.38,16.49 16.49,16.49 H 270.5 c 9.1,0 16.49,-7.38 16.49,-16.49 v -243.63"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4689" /></g><g
           id="g4691"
           transform="translate(175.3301,303.0596)"><path
             d="M 0,0 V 100.65"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4693" /></g><g
           id="g4695"
           transform="translate(225.7393,422.1006)"><path
             d="m 0,0 v -31.579 c 0,-2.961 2.4,-5.36 5.36,-5.36 h 31.579 c 2.96,0 5.36,2.399 5.36,5.36 V 0 c 0,2.961 -2.4,5.36 -5.36,5.36 H 5.36 C 2.4,5.36 0,2.961 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4697" /></g><g
           id="g4699"
           transform="translate(324.5884,385.1611)"><path
             d="M 0,0 H 87.32"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4701" /></g><g
           id="g4703"
           transform="translate(225.9502,329.0898)"><path
             d="m 0,0 c 0.64,2.24 2.71,3.88 5.15,3.88 h 31.58 c 2.96,0 5.36,-2.4 5.36,-5.359 V -33.06 c 0,-2.96 -2.4,-5.36 -5.36,-5.36 H 9.89"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4705" /></g><g
           id="g4707"
           transform="translate(324.5884,290.6738)"><path
             d="M 0,0 H 87.32"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4709" /></g><g
           id="g4711"
           transform="translate(225.7393,233.126)"><path
             d="m 0,0 v -31.579 c 0,-2.96 2.4,-5.36 5.36,-5.36 h 31.579 c 2.96,0 5.36,2.4 5.36,5.36 V 0 c 0,2.961 -2.4,5.36 -5.36,5.36 H 5.36 C 2.4,5.36 0,2.961 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4713" /></g><g
           id="g4715"
           transform="translate(137.3213,152.21)"><path
             d="M 0,0 C 6.806,-3.346 14.968,-2.168 20.552,2.964 L 38.041,19.04 c 17.842,16.4 21.178,43.312 7.879,63.571 l -4.759,7.25 c -1.735,2.644 -0.954,6.197 1.729,7.868 l 43.281,26.972 c 14.164,8.825 19.573,26.796 12.634,41.974 l -2.012,4.401 c -2.428,5.313 -8.867,7.432 -13.976,4.6 L -18.948,119.279 c -9.871,-5.469 -15.995,-15.867 -15.995,-27.152"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4717" /></g><g
           id="g4719"
           transform="translate(118.3735,271.4893)"><path
             d="M 0,0 C -9.871,-5.47 -15.996,-15.867 -15.996,-27.152 V -85.71 l -25,-27.229"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4721" /></g><g
           id="g4723"
           transform="translate(466.6646,76.0449)"><path
             d="m 0,0 c -16.166,-12.344 -36.363,-19.675 -58.272,-19.675 -53.08,0 -96.108,43.029 -96.108,96.109 0,53.078 43.028,96.107 96.108,96.107 53.079,0 96.107,-43.029 96.107,-96.107 0,-18.6 -5.283,-35.964 -14.43,-50.677"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4725" /></g><g
           id="g4727"
           transform="translate(415.3188,111.5322)"><path
             d="m 0,0 -17.911,73.743 c -1.161,4.782 -5.443,8.149 -10.364,8.149 -4.921,0 -9.204,-3.367 -10.365,-8.149 L -56.551,0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4729" /></g><g
           id="g4731"
           transform="translate(407.3901,144.1543)"><path
             d="M 0,0 H -40.694"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4733" /></g><g
           id="g4735"
           transform="translate(449.5864,193.4238)"><path
             d="M 0,0 V -40.945"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4737" /></g><g
           id="g4739"
           transform="translate(470.0596,172.9512)"><path
             d="M 0,0 H -40.946"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4741" /></g></g></g></g></svg>
</template>
